import React, { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { getCookie } from "../../utility/cookieProvider";
import { COOKIE } from "../../constants/app-constant";
import { deleteAllCookies } from "../../utility/cookieProvider";
import { httpPost } from "../../utility/requestHelper";
import { unifiedEnvConfig } from "../../constants/api-endpoint";
import { MoreBlueIcon } from "../Icons/icons.component";

export const UserDropdown = function () {
  const [userName, setUserName] = useState([]);

  useEffect(() => {
    let uName = [];
    try {
      const { firstName = "", lastName = "" } = JSON.parse(
        getCookie(COOKIE.CONCEPT_USER_NAME)
      );
      if (firstName) {
        uName.push(firstName);
      }
      if (lastName) {
        uName.push(lastName);
      }
      setUserName(uName);
    } catch {
      setUserName([]);
    }
  }, []);

  function logoutMe(e) {
    e.preventDefault();
    httpPost(`${unifiedEnvConfig.LOGOUT_URL}`).finally(() => {
      deleteAllCookies();
      localStorage.clear();
      sessionStorage.clear();
      window.location.href = "/";
    });
  }

  return (
    <Dropdown className="userMenuDropdown">
      <Dropdown.Toggle
        variant="default"
        id="dropdown-basic"
        title={userName.join(" ")}
      >
        {/* {userName.map((s) => s[0].toUpperCase())} */}
        <MoreBlueIcon />
      </Dropdown.Toggle>
      <Dropdown.Menu>
        <Dropdown.Item onClick={logoutMe}>Logout</Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};
